module.exports = __webpack_public_path__ + "static/media/card-discover.530fa535.svg";